import { TutorialConfig } from "../types/tutorial";

const predictiveTutorial: TutorialConfig = {
  pageId: "predictive",
  pageTitle: "Risk Prediction",
  steps: [
    {
      id: "predictive-intro",
      title: "Risk Prediction Overview",
      description:
        "Use machine learning to estimate the probability of shipment delays and identify which factors drive the risk score.",
      targetSelector: '[data-tutorial-step="predictive-title"]',
      position: "bottom",
    },
    {
      id: "predictive-summary",
      title: "Summary Cards",
      description:
        "These cards show the total shipments, delayed count, on-time count, and high-risk count across your network.",
      targetSelector: '[data-tutorial-step="predictive-summary"]',
      position: "bottom",
    },
    {
      id: "predictive-filters",
      title: "Filters",
      description:
        "Filter by product, destination, supplier, or search for a specific shipment to narrow the prediction table.",
      targetSelector: '[data-tutorial-step="predictive-filters"]',
      position: "bottom",
    },
    {
      id: "predictive-table",
      title: "Predictions Table",
      description:
        "Each row shows delay probability, predicted status, and key SHAP drivers. Click a row to see detailed risk factors.",
      targetSelector: '[data-tutorial-step="predictive-table"]',
      position: "top",
    },
  ],
};

export default predictiveTutorial;
